module.exports = __webpack_public_path__ + "img/9-twoImg.f6df78f7.png";